import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BaseComponent } from '@app/shared/components/base/base.component';


@Component({
    selector: 'app-photo-editor-dialog',
    templateUrl: './photo-editor-dialog.component.html',
    styleUrls: ['./photo-editor-dialog.component.scss']
})
export class PhotoEditorDialogComponent extends BaseComponent implements OnInit {

    constructor(public dialogRef: MatDialogRef<PhotoEditorDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data) {
        super();
        this._idPrefix = 'photo_editor_dialog.';
    }

    public ngOnInit() {
    }

    public close(): void {
        this.dialogRef.close(null);
    }

    public exportFile(dataUrl: string): void {
        this.dialogRef.close(dataUrl);
    }
}
